import { useQuery } from '@tanstack/react-query';
import inspectionApi from '../services/inspection.api';
import { inspectionKeys } from './useVehicleInspections';

const useMonthFolders = (year) =>
  useQuery({
    queryKey: inspectionKeys.monthFolders(year),
    queryFn: () => inspectionApi.getMonthFolders(year),
  });

export default useMonthFolders;
